<div #formContainer class="form-container">
    @if (actionParamsForm) {
        <clickatell-expansion-panel>
            <ng-container header>
                <mat-panel-title>
                    Parameters
                </mat-panel-title>
            </ng-container>
            <ng-container body>
                <form [formGroup]="actionParamsForm">
                    <div class="control-div">
                        <div class="control-label-container">
                            <label class="control-label"> Name </label>
                        </div>
                        <ng-container
                                *ngTemplateOutlet="validators; context: { myControlName: 'name', myForm: actionParamsForm}">
                        </ng-container>
                        <div [formGroup]="actionParamsForm">
                            <input class="control-input select_spacer"
                                   activeForm [activeForm]="actionParamsForm"
                                   id="name"
                                   [formControlName]="'name'"
                                   placeholder="Enter a name" style="resize: none"/>
                        </div>
                    </div>
                    <div class="control-div">
                        <div class="control-label-container">
                            <label class="control-label"> Description </label>
                        </div>
                        <ng-container
                                *ngTemplateOutlet="validators; context: { myControlName: 'description', myForm: actionParamsForm}"></ng-container>
                        <input class="control-input select_spacer" activeForm [activeForm]="actionParamsForm"
                               id="description" [formControlName]="'description'" placeholder="Enter description"/>
                    </div>
                    <div class="control-div">
                        <div class="control-label-container">
                            <label class="control-label"> Send to </label>
                        </div>
                        <ng-container
                                *ngTemplateOutlet="validators; context: { myControlName: 'sendTo', myForm: actionParamsForm}">
                        </ng-container>
                        <div [formGroup]="actionParamsForm">
                            <input class="control-input select_spacer"
                                   activeForm [activeForm]="actionParamsForm"
                                   id="sendTo"
                                   [formControlName]="'sendTo'"
                                   placeholder="Enter a MSISDN number" style="resize: none"/>
                        </div>
                    </div>
                    <div class="control-div">
                        <div class="control-label-container">
                            <label class="control-label"> Template Reference </label>
                            <label class="control-optional"> Optional </label>
                        </div>
                        <ng-container
                                *ngTemplateOutlet="validators; context: { myControlName: 'clientReferenceId', myForm: actionParamsForm}">
                        </ng-container>
                        <div [formGroup]="actionParamsForm">
                            <input class="control-input select_spacer"
                                   activeForm [activeForm]="actionParamsForm"
                                   id="clientReferenceId "
                                   [formControlName]="'clientReferenceId'"
                                   placeholder="Enter template reference" style="resize: none"/>
                        </div>
                    </div>
                    <div class="control-div">
                        <div class="control-label-container">
                            <label class="control-label"> Config mode </label>
                        </div>
                        <mat-button-toggle-group #configModeGroup="matButtonToggleGroup"
                                                 [value]="'default'"
                                                 [multiple]="false"
                                                 [formControlName]="'configMode'"
                                                 (change)="configModeChanged()"
                                                 class="control-input control-toggle-group"
                                                 hideSingleSelectionIndicator>
                            <mat-button-toggle class="selector-button" [value]="'default'">UI Config</mat-button-toggle>
                            <mat-button-toggle class="selector-button" [value]="'json'">JSON Config</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    @if (!loadInitData) {
                        @if (accountsError || integrationsError || templatesError) {
                            <div class="banner-container">
                                <div class="banner-block banner-error-block">
                                    <div class="icon icon-error"></div>
                                    <div class="content">
                                        @if (accountsError) {
                                            <span>Failed to load accounts. Please try again later.</span>
                                        } @else if (integrationsError) {
                                            <span>Failed to load integrations. Please try again later.</span>
                                        } @else if (templatesError) {
                                            <span>Failed to load templates. Please try again later.</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="control-div">
                            <div class="control-label-container">
                                <label class="control-label"> Select Account </label>
                            </div>
                            <ng-container
                                    *ngTemplateOutlet="validators; context: { myControlName: 'businessAccountId', myForm: actionParamsForm}">
                            </ng-container>
                            <div class="parent">
                                <input type="text"
                                       #businessAccountId
                                       placeholder="Search or select an Account"
                                       matInput
                                       [id]="'businessAccountId'"
                                       [activeForm]="actionParamsForm"
                                       class="layer1 control-select control-select-spacer"
                                       [formControlName]="'businessAccountId'"
                                       [matAutocomplete]="auto"
                                       (input)="wabaFilter(businessAccountId)"
                                />
                            </div>
                            <mat-autocomplete
                                    autoActiveFirstOption
                                    (optionSelected)="waBusinessAccountsChange($event['option']['value'])"
                                    (opened)="onFocusIn(formContainer, auto, 'businessAccountId')"
                                    (closed)="onFocusOut(formContainer)"
                                    #auto="matAutocomplete"
                                    [displayWith]="waBusinessAccountsDisplay.bind(this)"
                                    hideSingleSelectionIndicator>
                                <ng-container>
                                    @if (!waBusinessAccounts) {
                                        <mat-option disabled class="data-select-option"
                                                    [ngStyle]="{ 'line-height': 1 }">
                                            <div class="align-loading">
                                                <loading-icon></loading-icon>
                                            </div>
                                        </mat-option>
                                    }
                                    @if (waBusinessAccounts) {
                                        @if (waBusinessAccountsFiltered.length == 0) {
                                            <mat-option disabled
                                                        class="data-select-option-nonfound resNotFound"
                                                        [ngStyle]="{ 'line-height': 1 }">
                                                No results found.
                                            </mat-option>
                                        }
                                        @if (waBusinessAccountsFiltered.length > 0 && waBusinessAccountsFiltered[0].id != null) {
                                            @for (account of waBusinessAccountsFiltered; track account) {
                                                <mat-option
                                                        [value]="account.id"
                                                        [ngClass]="{'select-dropdown-option': account.id === actionParamsForm.controls['businessAccountId'].value}">
                                                    {{ account.wabaName }}
                                                </mat-option>
                                            }
                                        }
                                        @if (waBusinessAccounts[0].id == null) {
                                            <mat-option disabled class="data-select-option-nonfound resNotFound"
                                                        [ngStyle]="{ 'line-height': 1 }">
                                                No Accounts available.
                                            </mat-option>
                                        }
                                    }
                                </ng-container>
                            </mat-autocomplete>
                        </div>
                        <div class="control-div">
                            <div class="control-label-container">
                                <label class="control-label"> Select Integration </label>
                            </div>
                            <ng-container
                                    *ngTemplateOutlet="validators; context: { myControlName: 'integrationId', myForm: actionParamsForm}">
                            </ng-container>
                            <div class="parent">
                                <input type="text"
                                       #integrationId
                                       placeholder="Search or select an Integration"
                                       matInput
                                       [id]="'integrationId'"
                                       [activeForm]="actionParamsForm"
                                       class="layer1 control-select control-select-spacer"
                                       [formControlName]="'integrationId'"
                                       [matAutocomplete]="integrationAuto"
                                       (input)="waIntegrationsFilter(integrationId)"
                                />
                            </div>
                            <mat-autocomplete
                                    autoActiveFirstOption
                                    (optionSelected)="waIntegrationsChange($event['option']['value'])"
                                    #integrationAuto="matAutocomplete"
                                    [displayWith]="waIntegrationsDisplay.bind(this)"
                                    (opened)="onFocusIn(formContainer, integrationAuto, 'integrationId')"
                                    (closed)="onFocusOut(formContainer)"
                                    hideSingleSelectionIndicator>
                                <ng-container>
                                    @if (waIntegrationsLoading) {
                                        <mat-option disabled class="data-select-option"
                                                    [ngStyle]="{ 'line-height': 1 }">
                                            <div class="align-loading">
                                                <loading-icon></loading-icon>
                                            </div>
                                        </mat-option>
                                    }
                                    @if (!waIntegrationsLoading) {
                                        @if (waIntegrationsFiltered.length == 0) {
                                            <mat-option disabled
                                                        class="data-select-option-nonfound resNotFound"
                                                        [ngStyle]="{ 'line-height': 1 }">
                                                No results found.
                                            </mat-option>
                                        }
                                        @if (waIntegrationsFiltered.length > 0 && actionParamsForm.controls['businessAccountId']?.value?.length > 0) {
                                            @for (integration of waIntegrationsFiltered; track integration) {
                                                <mat-option
                                                        [value]="integration.integrationId"
                                                        [ngClass]="{'select-dropdown-option': integration.integrationId === actionParamsForm.controls['integrationId'].value}">
                                                    {{ integration.integrationName }}
                                                </mat-option>
                                            }
                                        }
                                    }
                                </ng-container>
                            </mat-autocomplete>
                        </div>
                    } @else {
                        <loading-icon class="align-loading"></loading-icon>
                    }
                    @switch (configModeGroup.value) {
                        @case ('default') {
                            @if (!loadInitData) {
                                <div class="control-div">
                                    <div class="control-label-container">
                                        <label class="control-label"> Select A Template </label>
                                        <app-cms class="popover" [type]="'nodeBuild'"
                                                 [field]="'sendTemplate'"></app-cms>
                                    </div>
                                    <ng-container
                                            *ngTemplateOutlet="validators; context: { myControlName: 'templateId', myForm: actionParamsForm}">
                                    </ng-container>
                                    <div class="parent">
                                        <input type="text"
                                               #templateId
                                               placeholder="Search or select a Template"
                                               matInput
                                               [id]="'templateId'"
                                               [activeForm]="actionParamsForm"
                                               class="layer1 control-select control-select-spacer"
                                               [formControlName]="'templateId'"
                                               [matAutocomplete]="templateAuto"
                                               (input)="waTemplatesFilter(templateId)"/>
                                    </div>
                                    <mat-autocomplete
                                            autoActiveFirstOption
                                            (optionSelected)="waTemplatesChange($event['option']['value'])"
                                            (opened)="onFocusIn(formContainer, templateAuto, 'templateId')"
                                            (closed)="onFocusOut(formContainer)"
                                            #templateAuto="matAutocomplete"
                                            [displayWith]="waTemplatesDisplay.bind(this)"
                                            hideSingleSelectionIndicator>
                                        <ng-container>
                                            @if (waTemplatesLoading) {
                                                <mat-option disabled class="data-select-option"
                                                            [ngStyle]="{ 'line-height': 1 }">
                                                    <div class="align-loading">
                                                        <loading-icon></loading-icon>
                                                    </div>
                                                </mat-option>
                                            }
                                            @if (!waTemplatesLoading) {
                                                @if (waTemplatesFiltered.length == 0) {
                                                    <mat-option disabled
                                                                class="data-select-option-nonfound resNotFound"
                                                                [ngStyle]="{ 'line-height': 1 }">
                                                        No results found.
                                                    </mat-option>
                                                }
                                                @if (waTemplatesFiltered.length > 0 && actionParamsForm.controls['integrationId']?.value?.length > 0) {
                                                    @for (template of waTemplatesFiltered; track template) {
                                                        <mat-option [value]="template.id"
                                                                    [ngClass]="{'select-dropdown-option': template.id === actionParamsForm.controls['templateId'].value}">
                                                            ({{ template.language?.shortName }}) {{ template.name }}
                                                        </mat-option>
                                                    }
                                                }
                                            }
                                        </ng-container>
                                    </mat-autocomplete>
                                </div>
                            }
                            <div class="control-div">
                                @if (actionParamsForm.controls['templateId']?.value.length > 0) {
                                    <div>
                                        <ng-container *ngTemplateOutlet="templatePreview"></ng-container>
                                    </div>
                                } @else {
                                    <div class="preview-box init">
                                        <p> Preview: </p>
                                        <div class="centreContent">
                                            <p class="template_placeholder">Select a template first to preview</p>
                                        </div>
                                    </div>
                                }
                            </div>
                            @if (actionParamsForm.controls['templateId']?.value.length > 0 && template) {
                                <ng-container *ngTemplateOutlet="templateInputs"></ng-container>
                            }
                        }
                        @case ('json') {
                            @if (templateContentForm) {
                                <div class="control-div">
                                    <div class="control-label-container">
                                        <label class="control-label"> Json Config </label>
                                    </div>
                                    <ng-container
                                            *ngTemplateOutlet="validators; context: { myControlName: 'jsonParameters', myForm: templateContentForm}">
                                    </ng-container>
                                    <div [formGroup]="templateContentForm">
                                        <input class="control-input select_spacer"
                                               activeForm [activeForm]="templateContentForm"
                                               id="jsonParameters"
                                               [formControlName]="'jsonParameters'"
                                               placeholder="Enter Json config" style="resize: none"/>
                                    </div>
                                </div>
                            }
                        }
                    }
                </form>
            </ng-container>
        </clickatell-expansion-panel>
        <clickatell-expansion-panel>
            <ng-container header>
                <mat-panel-title>
                    Next Step
                </mat-panel-title>
            </ng-container>
            <ng-container body>
                <ng-container>
                    <div class="control-div logic-div">
                        <div class="logic-item-title logic-item-success">Success</div>
                        <ng-container
                                *ngTemplateOutlet="next; context: { controlName: 'success', form: actionParamsForm}">
                        </ng-container>
                    </div>
                    <div class="control-div logic-div">
                        <div class="logic-item-title logic-item-error">Error</div>
                        <ng-container
                                *ngTemplateOutlet="next; context: { controlName: 'error', form: actionParamsForm}">
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </clickatell-expansion-panel>
    }
</div>

<ng-template #next let-controlName="controlName" let-form="form">
    <label class="point-to-label">
        Go To
        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
    </label>
    @if (nodeFlowDetails) {
        <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                       [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                       [name]="controlName"
                       [form]="form"
                       [disableFlowFilter]="true"
                       [stepId]="nodeFlowDetails.stepId">
            >
        </next-selector>
    }
</ng-template>

<ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
    @if (myForm.controls[myControlName]; as control) {
        @if (control.invalid && (control.dirty || control.touched)) {
            <div class="validationField">
                @for (error of control.errors | keyvalue; track error) {
                    <div>
                        <span class="fa fa-exclamation-circle"></span>
                        <span [id]="'validationField-' + myControlName">
                              {{ error.value }}
                            </span>
                    </div>
                }
            </div>
        }
    }
</ng-template>


<ng-template #templatePreview>
    @if (template?.status && template?.status != 'VALIDATED') {
        <ng-template [ngTemplateOutlet]="templateStatus"
                     [ngTemplateOutletContext]="{ status: template?.status }"></ng-template>
    } @else if (!loadInitData) {
        <div class="preview-box">
            <p> Preview: </p>
            @if (this.templateContentForm) {
                <wa-template-preview [waTemplateId]="actionParamsForm.controls['templateId']?.value">
                </wa-template-preview>
            }
        </div>
    }
</ng-template>

<ng-template #templateInputs>
    @if (templateContentForm) {
        <form [formGroup]="templateContentForm">
            @if (templateContentForm.controls['location']) {
                <form [formGroup]="templateContentForm.controls['location']">
                    <div class="qr-template-container">
                        <div class="qr-section title">
                            Location header
                        </div>
                        <div class="content">
                            <div class="qr-section add-param">
                                <button class="location-picker" (click)="showLocationPicker()">
                                    <div class="location-icon"></div>
                                    {{ !isLocationPicker ? 'Select' : 'Close' }} Location
                                </button>
                                @if (isLocationPicker) {
                                    <app-show-location
                                            [text]="'Select'"
                                            (onClickCancelView)="closeLocation($event)"
                                            (onShareLocationClick)="setLocation($event)">
                                    </app-show-location>
                                }
                            </div>
                            @if (!isLocationPicker) {
                                <div class="qr-section add-param">
                                    <div>
                                        <label class="control-label"> Latitude </label>
                                    </div>
                                    <ng-container
                                            *ngTemplateOutlet="validators; context: { myControlName: 'latitude', myForm: templateContentForm}">
                                    </ng-container>
                                    <input activeForm [activeForm]="actionParamsForm"
                                           id="latitude"
                                           [formControlName]="'latitude'"
                                           placeholder="E.g. -33.8811" style="resize: none"/>
                                </div>
                                <div class="qr-section add-param">
                                    <div>
                                        <label class="control-label"> Longitude </label>
                                    </div>
                                    <ng-container
                                            *ngTemplateOutlet="validators; context: { myControlName: 'longitude', myForm: templateContentForm}">
                                    </ng-container>
                                    <input activeForm [activeForm]="actionParamsForm"
                                           id="longitude"
                                           [formControlName]="'longitude'"
                                           placeholder="E.g. 18.63561" style="resize: none"/>
                                </div>
                                <div class="qr-section add-param">
                                    <div>
                                        <label class="control-label"> Location Name </label>
                                    </div>
                                    <ng-container
                                            *ngTemplateOutlet="validators; context: { myControlName: 'locationName', myForm: templateContentForm}">
                                    </ng-container>
                                    <input activeForm [activeForm]="actionParamsForm"
                                           id="locationName"
                                           [formControlName]="'locationName'"
                                           placeholder="Enter location name" style="resize: none"/>
                                </div>
                                <div class="qr-section add-param">
                                    <div>
                                        <label class="control-label"> Location Address </label>
                                    </div>
                                    <ng-container
                                            *ngTemplateOutlet="validators; context: { myControlName: 'address', myForm: templateContentForm}">
                                    </ng-container>
                                    <input activeForm [activeForm]="actionParamsForm"
                                           id="address"
                                           [formControlName]="'address'"
                                           placeholder="Enter location address" style="resize: none"/>
                                </div>
                            }
                        </div>
                    </div>
                </form>
            }
            @if (templateContentForm.controls['mediaVar']) {
                <ng-container *ngTemplateOutlet="mediaTemplate"></ng-container>
            }
            @if (templateContentForm.controls['headerVar']) {
                <div class="control-div">
                    <div class="control-label-container">
                        <label class="control-label"> Header Variable <span>{{</span>1<span>&#125;&#125;</span> </label>
                    </div>
                    <ng-container
                            *ngTemplateOutlet="validators; context: { myControlName: 'headerVar', myForm: templateContentForm}">
                    </ng-container>
                    <input class="control-input select_spacer"
                           activeForm [activeForm]="actionParamsForm"
                           id="headerVar"
                           [formControlName]="'headerVar'"
                           placeholder="Enter Header Variable" style="resize: none"/>
                </div>
            }
            @if (templateContentForm.controls['bodyVars']?.value.length > 0 && template) {
                <ng-container formArrayName="bodyVars">
                    @for (bodyVarForm of getBodyVars.controls; track bodyVarForm; let i = $index) {
                        <div class="control-div" [formGroup]="bodyVarForm">
                            <div class="control-label-container">
                                <label class="control-label"> Body Variable <span>{{ </span>{{ i + 1 }}
                                    <span>&#125;&#125;</span>
                                </label>
                            </div>
                            <ng-container
                                    *ngTemplateOutlet="validators; context: { myControlName: 'bodyVariable', myForm: bodyVarForm}">
                            </ng-container>
                            <input class="control-input select_spacer"
                                   activeForm
                                   [activeForm]="templateContentForm"
                                   type="text"
                                   formControlName="bodyVariable"
                                   placeholder="Enter Body Variable {{i+1}}" style="resize: none"/>
                        </div>
                    }
                </ng-container>
            }
            @if (templateContentForm.controls['websiteUrls']?.value.length > 0 || templateContentForm.controls['url']?.value.length > 0 && template) {
                <ng-container formArrayName="websiteUrls">
                    @for (websiteUrlsForm of getWebsiteUrls.controls; track websiteUrlsForm; let i = $index) {
                        <div class="control-div" [formGroup]="websiteUrlsForm">
                            <div class="control-label-container">
                                <label class="control-label"> Dynamic Link for
                                    <span>{{</span>{{ template | arrayTemplateFilter: i }}<span>&#125;&#125;</span>
                                </label>
                            </div>
                            <ng-container
                                    *ngTemplateOutlet="validators; context: { myControlName: 'url', myForm: websiteUrlsForm}">
                            </ng-container>
                            <input class="control-input select_spacer"
                                   activeForm
                                   [activeForm]="templateContentForm"
                                   type="text"
                                   [formControlName]="'url'"
                                   placeholder="Enter Dynamic Link {{i+1}}" style="resize: none"/>
                        </div>
                    }
                </ng-container>
            }
            @if (templateContentForm.controls['couponCode']) {
                <div class="control-div">
                    <div class="control-label-container">
                        <label class="control-label"> Coupon Code </label>
                    </div>
                    <ng-container
                            *ngTemplateOutlet="validators; context: { myControlName: 'couponCode', myForm: templateContentForm}">
                    </ng-container>
                    <input class="control-input select_spacer"
                           activeForm [activeForm]="actionParamsForm"
                           id="couponCodeVar"
                           [formControlName]="'couponCode'"
                           placeholder="Enter Coupon Code" style="resize: none"/>
                </div>
            }
            @if (templateContentForm.controls['otp']) {
                <div class="control-div">
                    <div class="control-label-container">
                        <label class="control-label"> One-Time Password </label>
                    </div>
                    <ng-container
                            *ngTemplateOutlet="validators; context: { myControlName: 'otp', myForm: templateContentForm}">
                    </ng-container>
                    <input class="control-input select_spacer"
                           activeForm [activeForm]="actionParamsForm"
                           id="otpVar"
                           [formControlName]="'otp'"
                           placeholder="Enter a One-Time Password" style="resize: none"/>
                </div>
            }
            @if (templateContentForm.controls['suggestedResponse']) {
                @for (suggestedResponseKey of templateContentForm.controls['suggestedResponse'].controls | getObjectKeys; track suggestedResponseKey; let i = $index) {
                    <ng-container
                            *ngTemplateOutlet="quickReplyTemplate; context: {title: template.templateContent.buttons.quickReply[i], index: suggestedResponseKey}"></ng-container>
                }
            }
        </form>
    }


</ng-template>

<ng-template #quickReplyTemplate let-title='title' let-index='index'>
    <div class="qr-template-container"
         [formGroup]="templateContentForm.controls['suggestedResponse']['controls'][index]">
        <div class="qr-section title">
            Button routing
        </div>
        <div class="content">
            <div class="qr-section qr-button-container">
                <p class="qr-button">{{ title.text }}</p>
            </div>
            <ng-container
                    *ngTemplateOutlet="validators; context: { myControlName: 'flowStep', myForm: templateContentForm.controls['suggestedResponse']['controls'][index]}">
            </ng-container>
            <div class="qr-section point-to">
                <label class="control-label"> Link To Step Or Flow </label>

                @if (nodeFlowDetails) {
                    <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                                   [noNewStep]="true"
                                   [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                                   [name]="'flowStep'"
                                   [disableFlowFilter]="true"
                                   [form]="templateContentForm.controls['suggestedResponse']['controls'][index]"
                                   [stepId]="nodeFlowDetails.stepId">
                    </next-selector>
                }
            </div>
            <div class="qr-section add-param">
                <div>
                    <label class="control-label"> Additional Parameter </label>
                    <label class="control-optional">Optional</label>
                </div>

                @if (templateContentForm.controls['suggestedResponse']['controls'][index].errors?.['additionalDataMaxLength']) {
                    <div class="validationField"
                    >
                        <span class="fa fa-exclamation-circle"></span>
                        <span [id]="'validationField-suggestedResponse'">
                                                {{ templateContentForm.controls['suggestedResponse']['controls'][index].errors?.['additionalDataMaxLength'] }}
                                              </span>
                    </div>
                }

                <textarea rows="1" formControlName="additionalData"></textarea>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mediaTemplate>

    <div class="control-div">
        <mat-button-toggle-group #mediaToggle="matButtonToggleGroup" [value]="selectedMediaType"
                                 class="control-input select_spacer media_toggle_group" multiple="false"
                                 (change)="mediaTypeChange(mediaToggle)"
                                 hideSingleSelectionIndicator>
            <mat-button-toggle class="selector-button" value="assets">Assets</mat-button-toggle>
            <mat-button-toggle class="selector-button" value="variable">Variable</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <form [formGroup]="templateContentForm">
        <ng-container
                *ngTemplateOutlet="validators; context: { myControlName: 'mediaVar', myForm: templateContentForm}">
        </ng-container>
        @if (mediaToggle.value == 'assets') {
            <div class="control-div">
                <div class="control-div">
                    <input #imageRef [formControlName]="'mediaVar'" hidden>
                    <select-media [image]="imageRef.value" [mediaFilter]="template.templateContent.header.media.type"
                                  (setImageRef)="setImage($event)">
                    </select-media>
                </div>
            </div>
        } @else {
            <div class="control-label-container">
                <label class="control-label"> Media </label>
            </div>
            <input class="control-input select_spacer"
                   activeForm [activeForm]="templateContentForm"
                   id="mediaVar"
                   [formControlName]="'mediaVar'"
                   placeholder="Enter a variable" style="resize: none"/>
        }
    </form>
</ng-template>

<ng-template #templateStatus let-status="status">
    <div class="banner-container">
        <div class="banner-block banner-error-block">
            <div class="icon icon-error "></div>
            <div class="content">
                @switch (status) {
                    @case ('AWAITING_VALIDATION') {
                        <span>Template is waiting for approval</span>
                    }
                    @case ('SUBMITTED') {
                        <span>Template was submitted</span>
                    }
                    @case ('REJECTED') {
                        <span>Template was rejected. Please configure a different template</span>
                    }
                    @case ('DEACTIVATED') {
                        <span>Template is deactivated. Please configure a different template</span>
                    }
                    @case ('LOADING_ERROR') {
                        <span>There was an error loading the template.</span>
                    }
                }
            </div>
        </div>
    </div>
</ng-template>